import { parseUKDate, formatDateUK } from './meterChange.helpers';

const HEADER_ALIASES = {
  ReqType:   ['ReqType', 'Req Type', 'Type'],
  Unit:      ['Unit', 'Train'],
  EVN:       ['EVN'],
  OldMeter:  ['OldMeter', 'Old Meter', 'Old_Meter'],
  NewMeter:  ['NewMeter', 'New Meter', 'New_Meter'],
  NewEFDT:   ['NewEFDT', 'New EFDT', 'New_EFDT', 'NewEFDT'],
  OldETDT:   ['OldETDT', 'Old ETDT', 'Old_ETDT', 'OldETDT'],
  Comments:  ['Comments', 'Comment', 'Notes'],
};

const REQUIRED_KEYS = ['ReqType', 'Unit', 'EVN', 'OldMeter', 'NewMeter', 'NewEFDT', 'OldETDT'];
const DELIMS = ['\t', ',', ';'];

const detectDelimiter = (headerLine) => {
  return DELIMS.reduce((best, d) => {
    const count = headerLine.split(d).length;
    return count > headerLine.split(best).length ? d : best;
  }, '\t');
};

const buildHeaderIndex = (headers) => {
  const map = {};
  Object.entries(HEADER_ALIASES).forEach(([key, aliases]) => {
    for (const alias of aliases) {
      const idx = headers.findIndex((h) => h === alias);
      if (idx !== -1) {
        map[key] = { headerName: alias, index: idx };
        break;
      }
    }
  });
  return map;
};

export const parseMeterChangeFile = (text) => {
  const lines = text.split(/\r?\n/);
  if (!lines.length || lines[0].trim() === '') {
    return { success: false, message: 'File is empty.', rows: [] };
  }

  const headerLine = lines[0];
  const delim = detectDelimiter(headerLine);
  const headers = headerLine.split(delim).map((h) => h.trim());

  const headerIndex = buildHeaderIndex(headers);
  const missingHeaderLabels = REQUIRED_KEYS
    .filter((k) => !(k in headerIndex))
    .map((k) => (HEADER_ALIASES[k] && HEADER_ALIASES[k][0]) || k);

  if (missingHeaderLabels.length) {
    return {
      success: false,
      message: `Header mismatch. Missing column(s): ${missingHeaderLabels.join(', ')}`,
      rows: [],
    };
  }

  const rows = [];
  const dataLines = lines.slice(1);

  for (let i = 0; i < dataLines.length; i++) {
    const raw = dataLines[i];
    if (!raw || raw.trim() === '') continue;

    const cells = raw.split(delim).map((v) => (v == null ? '' : v.trim()));
    const hasAnyData = cells.some((c) => c !== '');
    if (!hasAnyData) continue;

    const get = (k) => {
      const meta = headerIndex[k];
      if (!meta) return '';
      const idx = meta.index;
      return cells[idx] == null ? '' : cells[idx];
    };

    const fileRowNum = i + 2;

    rows.push({
      ReqType: get('ReqType') || 'EM',
      Unit: get('Unit'),
      EVN: get('EVN'),
      OldMeter: get('OldMeter'),
      NewMeter: get('NewMeter'),
        NewEFDT: (() => {
          const d = parseUKDate(get('NewEFDT'));
          return d instanceof Date && !isNaN(d) ? formatDateUK(d) : get('NewEFDT');
        })(),
        OldETDT: (() => {
          const d = parseUKDate(get('OldETDT'));
          return d instanceof Date && !isNaN(d) ? formatDateUK(d) : get('OldETDT');
        })(),
      Comments: get('Comments'),
      Validated: false,
      _originalIndex: rows.length,
      _fileRowNum: fileRowNum,
    });
  }

  return {
    success: true,
    message: `${rows.length} row(s) imported successfully.`,
    rows,
  };
};
